import React from "react";
import { MessageCircle } from "lucide-react";

// Bindni Jewels WhatsApp Catalogue
export const WA_CATALOG_URL = "https://wa.me/c/917987780925";
export const WA_PHONE_INTL = "+91 79877 80925";
export const WA_NUMBER_DIGITS = "917987780925";
export const INSTAGRAM_URL = "https://www.instagram.com/bindni_jewels";
export const INSTAGRAM_HANDLE = "@bindni_jewels";

const MSG = encodeURIComponent("Namaste! I'd like to know more about Bindni Jewels.");

export const WhatsAppButton = () => (
  <a
    href={WA_CATALOG_URL}
    target="_blank"
    rel="noreferrer"
    className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform duration-200"
    aria-label="WhatsApp Catalogue"
    title="View our WhatsApp Catalogue"
    data-testid="whatsapp-float-btn"
  >
    <MessageCircle size={26} strokeWidth={1.8} />
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
  </a>
);

export default WhatsAppButton;
